
import { Column } from "primereact/column";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../components/MeaButton";
import MeaDataTable from "../../../components/MeaDataTable";
import trainingsAPI from "../../../services/trainings";
import MeaLink from "../../../components/MeaLink";
//import UpdateTrainingModal from "../../../training/detail/components/UpdateTrainingModal";
import { PERMISSION_SCHOOL_TRAININGS } from "../../../permissions";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Tag } from "primereact/tag";
import { useNavigate } from "react-router-dom";

const RegistrationsListComponent = forwardRef((props, ref) => {
  const { showAddButton, targetSection = "candidates" } = props;
  const { auth, currentMembership, hasPermission } = useAuthContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  const schoolId = currentMembership?.school_id;
  const accessToken = auth?.access_token;
  //
  //
  const [state, setState] = useUrlState({
    trainingName: "",
    trainingStatus: "DRAFT,OPEN",
  });
  const [training, setTraining] = useState(null);
  const navigate = useNavigate();
  //
  const queryList = trainingsAPI.useGetList(
    schoolId,
    accessToken,
    page,
    pageSize,
    state.trainingStatus
  );
  //
  useEffect(() => {
    console.log(queryList?.data?.data);
    if (queryList?.data?.data?.length === 1) {
      navigate(`/school/${schoolId}/admin/registrations/${queryList?.data?.data[0]?.id}/${targetSection}`, { replace: true });
    }
  }, [queryList?.data, schoolId, navigate, targetSection]);
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //

  //
  return (
    <>
      <MeaDataTable
        query={queryList}

        serviceAPI={trainingsAPI}
        names={{
          pagination: "trainings",
          singular: "formation",
          plural: "formations",
        }}
        showDeleteButton={false}
        //showFilterButton={showFilterButton}
        setPage={setPage}
        setPageSize={setPageSize}
        schoolId={schoolId}
        rowClassName={(rowData) => {
          if (rowData.status === "OPEN") {
            return 'bg-green-100';
          } else if (rowData.status === "DRAFT") {
            return 'bg-blue-100';
          } else if (rowData.status === "SUSPENDED") {
            return 'bg-red-100';
          } else if (rowData.status === "ARCHIVED") {
            return 'bg-gray-100';
          } else {
            return '';
          }
        }}
      >
        <Column
          field="status"
          header="Statut"
          body={(item) => {
            return item?.status ? (
              <Tag
                value={
                  item.status === "OPEN"
                    ? "Ouvert"
                    : item.status === "DRAFT"
                      ? "Brouillon"
                      : item.status === "SUSPENDED"
                        ? "Suspendu"
                        : item.status === "ARCHIVED"
                          ? "Archivé"
                          : item.status
                }
                severity={
                  item.status === "OPEN"
                    ? "success"
                    : item.status === "DRAFT"
                      ? "info"
                      : item.status === "SUSPENDED"
                        ? "warning"
                        : item.status === "ARCHIVED"
                          ? "contrast"
                          : null
                }
              />
            ) : (
              "-"
            );
          }}
        ></Column>
        <Column
          field="name"
          header="Formation"
          body={(item) => (
            <MeaLink to={"/school/" + schoolId + "/admin/registrations/" + item.id + "/" + targetSection} permission={PERMISSION_SCHOOL_TRAININGS.GET}>
              {item.name}
            </MeaLink>
          )}
        ></Column>
        <Column
          field="start_registration_date"
          header="Date de début des inscriptions"
          body={(item) => {
            return item?.start_registration_date ? new Date(item?.start_registration_date).toLocaleDateString("fr-FR") : "-";
          }}
        ></Column>
        <Column
          field="end_registration_date"
          header="Date de fin des inscriptions"
          body={(item) => {
            return item?.end_registration_date ? new Date(item?.end_registration_date).toLocaleDateString("fr-FR") : "-";
          }}
        ></Column>


      </MeaDataTable>
      {/* <UpdateTrainingModal ref={updateModalRef} training={training} query={queryList} /> */}
    </>
  );
});

export default RegistrationsListComponent;
